import BaseDB from 'libs/DB/BaseDB'

/**
 * BaseDB가 wrap한 record를 직접 타입으로 정의 (jmapDownloadCache 패턴).
 * data: 보안 메일 만료 정보 페이로드 (expired_date만).
 */
export interface SecureMailStatusCacheRecord {
  secure_mail_id: string
  data: { expired_date: string | null }
  expireTime?: number | null
  isExpired?: () => boolean
}

/**
 * 보안 메일 만료 정보 캐시 — 본 캐시는 expired_date만 저장한다.
 * 저장 조건: getSecureMailStatus 응답을 받을 때마다 (만료 정보는 spec 상 변경되지 않음).
 *
 * 조회 흐름:
 *   - 캐시 hit & expired_date < now → API 호출 스킵 + viewer 전달 안 함 (만료된 보안 메일은 일반 메일처럼 표시)
 *   - 캐시 hit & expired_date 미래 → API 호출 (상태 자체는 항상 fresh fetch — 보낸 사람이 변경 가능)
 *   - 캐시 miss → API 호출 → expired_date 캐시 저장
 *
 * 사용:
 *   addData(secureMailId, { expired_date })
 *   getData(secureMailId).data.expired_date
 */
const secureMailStatusCacheDB = new BaseDB<SecureMailStatusCacheRecord>('secureMailStatusCacheDB', {
  version: 1,
  key: 'secure_mail_id',
  expireDuration: 30 * 24 * 60 * 60 * 1000, // 30일
  skipPreload: true,
})

export default secureMailStatusCacheDB
